import { Terminal as TTerminal } from "./Terminal/Terminal";

export const Terminal = new TTerminal();
